export const FF_RESHARING = 'keap.sharing.internal.resharing';
export const FF_CART_LINK_BUSINESS_ADVISOR = 'keap.sharing.cart.link.co.sell.pilot';
export const FF_SHARING_SHOW_PATH_TO_FAILED_ITEM = 'keap.sharing.show.path.to.failed.item';
export const FF_SHARING_FEATURE_COMPATIBILITY = 'keap.sharing.feature.compatibility';
export const FF_SLP_INSTALL_TRACING = 'keap.sharing.backend.install.tracing';
export const FF_SLP_EXPORT_TRACING = 'keap.sharing.backend.export.tracing';
export const FF_DOWNLOAD_INSTALL_HISTORY = 'keap.sharing.install.reporting.download.installs';
export const FF_SLP_SHOW_DETAILED_CUSTOM_FIELD_ERRORS = 'keap.sharing.show.detailed.custom.field.errors';
export const FF_OOE_CART_LINKS = 'keap.sharing.ooe.cart.links';

// Shareable resource types
export const FF_SHARING_SAVED_SEARCH_CONTACT = 'keap.sharing.type.savedSearch.contact';
export const FF_SHARING_SAVED_SEARCH_COMPANY = 'keap.sharing.type.savedSearch.company';
export const FF_SHARING_SAVED_SEARCH_ORDER = 'keap.sharing.type.savedSearch.order';
export const FF_SHARING_SAVED_SEARCH_REFERRAL_PARTNER = 'keap.sharing.type.savedSearch.referralPartner';
export const FF_SHARING_SAVED_SEARCH_SUBSCRIPTION = 'keap.sharing.type.savedSearch.subscription';
export const FF_SHARING_SAVED_SEARCH_VISITOR = 'keap.sharing.type.savedSearch.visitor';
export const FF_SHARING_TEXT_TEMPLATE_EMAIL = 'keap.sharing.type.textTemplate.email';
export const FF_SHARING_TEXT_TEMPLATE_SMS_BROADCAST = 'keap.sharing.type.textTemplate.smsBroadcast';
export const FF_SHARING_TEXT_TEMPLATE_SMS_AUTOMATION = 'keap.sharing.type.textTemplate.smsAutomation';
export const FF_SHARING_TEXT_TEMPLATE_SMS_CUSTOM = 'keap.sharing.type.textTemplate.smsCustom';
export const FF_SHARING_ROLES = 'keap.sharing.type.role';
export const FF_SHARING_LANDING_PAGE_POPUP = 'keap.sharing.type.popup';
